import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
export class TrezorException extends ConcreteException {
    static errorClass = 'TrezorException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        this.setName(TrezorException.errorClass);
    }
}
